// src/components/footer/Footer.js
import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { useTranslation } from "react-i18next";

export default function Footer(props) {
  const { t } = useTranslation();

  return (
    <div className="footer-div">
      <Fade>
        <p className="footer-text" style={{ color: props.theme.secondaryText }}>
          {t("footer.madeWithBy", {
            name: t("home.title")
          })}
        </p>
      </Fade>
    </div>
  );
}